import { Route, Routes } from 'react-router-dom';

import ChiTietHoaDon from './chi-tiet-hoa-don';
import NhanPmkt from './nhan-pmkt';
import Pl432022Qh15 from './pl43-2022-qh15';
import TongHopHoaDon from './tong-hop-hoa-don';
import TinhHinhSuDung from './tinh-hinh-su-dung';
import TongHopMau01 from './tong-hop-mau-01';
import Phuluc01 from './phu-luc-01';
import TrangThaiMst from './trang-thai-mst';
import { ROLE } from '../../Constant';
import { PrivateRoute } from '../components/PrivateRoute';
import TongHopHoaDonXangDau from './tong-hop-hoa-don-xang-dau';
import { BangTongHop } from './bang-tong-hop';

export default function BaoCao() {

  return (
    <Routes>
      <Route path="chi-tiet-hoa-don" element={<PrivateRoute role={ROLE.REPORT_DETAIL}> <ChiTietHoaDon /></PrivateRoute>} />
      <Route path="nhan-pmkt" element={<PrivateRoute role={ROLE.REPORT_PMKT}> <NhanPmkt /></PrivateRoute>} />
      <Route path="bang-tong-hop" element={<BangTongHop />} />
      <Route path="pl43-2022-qh15" element={<PrivateRoute role={ROLE.REPORT_PLQH}> <Pl432022Qh15 /></PrivateRoute>} />
      <Route path="tinh-hinh-su-dung" element={<PrivateRoute role={ROLE.REPORT_SUMMARY}> <TinhHinhSuDung /></PrivateRoute>} />
      <Route path="tong-hop-hoa-don" element={<PrivateRoute role={ROLE.REPORT_SUMMARY}> <TongHopHoaDon /></PrivateRoute>} />
      {/* <Route path="tong-hop-mau-01"  element={<PrivateRoute role={ROLE.REPORT_SUMMARY01}> <TongHopMau01/></PrivateRoute>}/> */}
      <Route path="phu-luc-01" element={<PrivateRoute role={ROLE.REPORT_PLQH01}> <Phuluc01 /></PrivateRoute>} />
      <Route path="trang-thai-mst" element={<PrivateRoute role={ROLE.INVOICE_MANAGEMENT}> <TrangThaiMst /></PrivateRoute>} />
      <Route path="tong-hop-hoa-don-xang-dau" element={<PrivateRoute role={ROLE.REPORT_SUMMARY}> <TongHopHoaDonXangDau /></PrivateRoute>} />
    </Routes>
  );
}
